// Navigation utilities for role-based routing
export const getDashboardRoute = (role: string): string => {
  switch (role) {
    case 'teacher':
      return '/teacher/dashboard';
    case 'student':
      return '/student/dashboard';
    case 'parent':
      return '/parent/dashboard';
    case 'admin':
      return '/admin/dashboard';
    case 'supervisor':
      return '/teacher/dashboard'; // المشرف يستخدم نفس داشبورد المعلم
    case 'employee':
      return '/employee/dashboard';
    default:
      return '/dashboard';
  }
};

export const getDefaultRoute = (role: string): string => {
  return getDashboardRoute(role);
};

export const getRoleDisplayName = (role: string): string => {
  switch (role) {
    case 'teacher':
      return 'معلم';
    case 'student':
      return 'طالب';
    case 'parent':
      return 'ولي أمر';
    case 'admin':
      return 'مدير';
    case 'supervisor':
      return 'مشرف';
    case 'employee':
      return 'موظف';
    default:
      return 'مستخدم';
  }
};

export const getRoleColor = (role: string) => {
  switch (role) {
    case 'teacher':
      return {
        bg: 'bg-blue-50 dark:bg-blue-900/20',
        text: 'text-blue-600 dark:text-blue-400',
        gradient: 'from-blue-500 to-indigo-600',
      };
    case 'student':
      return {
        bg: 'bg-green-50 dark:bg-green-900/20',
        text: 'text-green-600 dark:text-green-400',
        gradient: 'from-green-500 to-emerald-600',
      };
    case 'parent':
      return {
        bg: 'bg-purple-50 dark:bg-purple-900/20',
        text: 'text-purple-600 dark:text-purple-400',
        gradient: 'from-purple-500 to-violet-600',
      };
    case 'admin':
      return {
        bg: 'bg-red-50 dark:bg-red-900/20',
        text: 'text-red-600 dark:text-red-400',
        gradient: 'from-red-500 to-pink-600',
      };
    case 'supervisor':
      return {
        bg: 'bg-indigo-50 dark:bg-indigo-900/20',
        text: 'text-indigo-600 dark:text-indigo-400',
        gradient: 'from-indigo-500 to-purple-600',
      };
    case 'employee':
      return {
        bg: 'bg-orange-50 dark:bg-orange-900/20',
        text: 'text-orange-600 dark:text-orange-400',
        gradient: 'from-orange-500 to-amber-600',
      };
    default:
      return {
        bg: 'bg-gray-50 dark:bg-gray-900/20',
        text: 'text-gray-600 dark:text-gray-400',
        gradient: 'from-gray-500 to-gray-600',
      };
  }
};

// Check if user has permission to access certain features
export const hasPermission = (
  userRole: string,
  requiredRole: string | string[]
): boolean => {
  if (Array.isArray(requiredRole)) {
    return requiredRole.includes(userRole);
  }

  // Admin has access to everything
  if (userRole === 'admin') {
    return true;
  }

  return userRole === requiredRole;
};

// Role hierarchy for permissions
export const roleHierarchy = {
  admin: 5,
  supervisor: 5, // نفس مستوى المدير
  teacher: 4,
  employee: 3,
  parent: 2,
  student: 1,
};

export const hasHigherOrEqualRole = (
  userRole: string,
  minimumRole: string
): boolean => {
  const userLevel = roleHierarchy[userRole as keyof typeof roleHierarchy] || 0;
  const minimumLevel =
    roleHierarchy[minimumRole as keyof typeof roleHierarchy] || 0;
  return userLevel >= minimumLevel;
};
